export const REDIRECT_URI = '/dashboard';
export const POST_LOGOUT_REDIRECT_URI = '/login';
export const SCOPE = 'openid profile';
export const RESPONSE_TYPE = 'code';
export const LOGOUT = '/logout';
